module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img10.c722d59b.jpg";